import { PortfolioRepo } from '@services/portfolio.repo'
import * as _ from 'lodash'
import * as angular from 'angular'
import { TradeSheet } from '@models/trading/tradeSheet';
import { TradingRepo } from '@services/trading.repo';
import { extractErrorMessage } from '@common/utils/errorUtils';

class CancelTradeSheetDialogController {



    public isLoading: boolean = false;

    public tradeSheet: TradeSheet;
    public comment: string = "";

    /** @ngInject */
    constructor(private $mdDialog: angular.material.IDialogService, private portfolioRepo: PortfolioRepo, private notifyjs, private tradingRepo: TradingRepo) {

    }

    $onInit() {
    }


    save() {
        let that = this;
        that.isLoading = true;
        that.tradeSheet.reason = that.comment;

        that.tradingRepo.cancelTradeSheetAsAdmin(that.tradeSheet.id, that.tradeSheet)
            .then(
            ).catch(err => {
                that.notifyjs(extractErrorMessage(err));
            })
            .finally(() => {
                that.isLoading = false;
                that.$mdDialog.hide();
            });

    }

    cancel() {
        this.$mdDialog.cancel();
    }

}

export const cancelTradeSheetDialog: angular.IComponentOptions = {
    template: require('./cancelTradeSheet.dialog.html'),
    controller: CancelTradeSheetDialogController,
    bindings: {
        tradeSheet: "<"
    }

}



// WEBPACK FOOTER //
// ./src/app/tradingadmin/tradesheets/cancelTradeSheetDialog/cancelTradeSheet.dialog.ts